import { Action } from '@ngrx/store';
import { IHeaderChangedState } from '../model/header-changed.model';


export const APP_HEADER_STATE_CHANGED = 'HEADER_STATE_CHANGED';

export class HeaderChanged implements Action {
  readonly type = APP_HEADER_STATE_CHANGED;
  constructor(public payload: IHeaderChangedState) { }
}


export type HeaderActions =
  | HeaderChanged;
